module.exports = __webpack_public_path__ + "static/media/yy_code.bc1a6003.png";